<template>
  <ol class="list-group list-group-numbered list-group-flush">
    <li class="list-group-item" v-for="file in dados_arquivos_aula" :key="file.id">
      - {{ file.nome_arquivo }}
      <div class="float-end">
        <a class="btn btn-sm btn-info text-light mx-1"
          :href="$api_link + 'download/file/' + file.nome_arquivo + '/' + file.id_aula" target="_blank">
          <i class="bi bi-cloud-arrow-down"></i>
          Baixar
        </a>
      </div>
    </li>
  </ol>
</template>

<script>
export default {
  name: 'ListaArquivos',
  props: {
    dados_arquivos_aula: {
      default: {}
    }
  }
}
</script>

<style></style>